
import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { 
  Dialog, 
  DialogContent, 
  DialogDescription, 
  DialogFooter, 
  DialogHeader, 
  DialogTitle 
} from '@/components/ui/dialog';

interface DeleteTrackDialogProps {
  isOpen: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  trackId?: string;
}

const DeleteTrackDialog: React.FC<DeleteTrackDialogProps> = ({ 
  isOpen, 
  isDeleting,
  onClose, 
  onConfirm,
  trackId
}) => {
  console.log("Delete dialog opened for track:", trackId, "isDeleting:", isDeleting);
  
  const handleConfirmDelete = async () => {
    if (isDeleting) return; // Prevent multiple clicks
    
    console.log("Confirm delete button clicked for track:", trackId);
    try {
      await onConfirm();
      console.log("Delete confirmation handler completed");
    } catch (error) {
      console.error("Error in delete confirmation:", error);
    }
  };

  // Prevent closing the dialog while deletion is in progress
  const handleOpenChange = (open: boolean) => {
    if (!open && !isDeleting) {
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-md mx-auto">
        <DialogHeader>
          <DialogTitle>Delete Track</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this track? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row gap-2 sm:gap-0">
          <Button 
            variant="outline" 
            onClick={onClose} 
            disabled={isDeleting} 
            className="w-full sm:w-auto"
          >
            Cancel
          </Button>
          <Button 
            variant="destructive" 
            onClick={handleConfirmDelete}
            disabled={isDeleting}
            className="w-full sm:w-auto text-white font-medium"
          >
            {isDeleting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Deleting...
              </>
            ) : (
              'Delete Track'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteTrackDialog;
